import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentaBancarias";
import moment from "moment";
import { Mensaje } from "../mensajes2";
import CatalogoProveedorPresupuesto from "../../catalogos/catalogoProveedorm";



export const ImpOrdenesPago = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

  const post = JSON.parse(localStorage.getItem("post"));

  // --- ESTADO PARA VISIBILIDAD DE PROVEEDOR ---
  const [modoProveedor, setModoProveedor] = useState('seleccionar');
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);


  // --- ESTADO PARA MENSAJES ---
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: '',
    texto: '',
    icono: 'informacion'
  });

  // --- REFS ---
  // Fechas
  const fechaDesdeRef = useRef();
  const fechaHastaRef = useRef();

  // Banco
  const bancoCodigoRef = useRef();
  const bancoNombreRef = useRef();

  // Agrupado por Tipo de Ordenes
  const radioAgrupSiRef = useRef();
  const radioAgrupNoRef = useRef();
  const radioAgrupDetalleRef = useRef();

  // Estado (Todas, Pagadas, Por Pagar, Anuladas)
  const radioEstadoTodasRef = useRef();
  const radioEstadoPagadasRef = useRef();
  const radioEstadoPorPagarRef = useRef();
  const radioEstadoAnuladasRef = useRef();

  // Estado 105
  const radioEstadoTodasCausas = useRef();
  const radioEstadoCausados = useRef();
  const radioEstadoPorCausar = useRef();

  // Tipo de Ordenes (Resumen Check + Radios)
  const checkResumenRef = useRef();
  const radioTipoOrdTodasRef = useRef();
  const radioTipoOrdPresupRef = useRef();
  const radioTipoOrdFinanRef = useRef();
  const radioTipoOrdTercerosRef = useRef();

  // Selects
  const tipoCompromisoRef = useRef();
  const ubicacionRef = useRef();
  const tipoOrdenRef = useRef();

  // Proveedor
  const radioProvSelectRef = useRef();
  const radioProvTodosRef = useRef();
  const provCodigoRef = useRef();
  const provNombreRef = useRef();

  // Ubicación Compromisos (No usado en lógica actual, pero referenciado en JSX original)
  const radioUbiCausadosRef = useRef();
  const radioUbiPorCausarRef = useRef();
  const radioUbiTodasRef = useRef();

  const opcionesCompromiso = [
    { value: "100", label: "TODOS" },
    { value: "5", label: "ORDEN DE COMPRA" },
    { value: "7", label: "PAGO DE OBRAS/SERVICIOS" },
    { value: "11", label: "ORDEN DE SERVICIO" },
    { value: "12", label: "PAGO DIRECTO" },
    { value: "13", label: "PAGO DE NOMINA" }
  ];

  const ubicaciones = [
    { value: "100", label: "TODOS" },
    { value: "44", label: "TESORERIA POR CHEQUE" },
    { value: "45", label: "DESPACHO" },
    { value: "46", label: "TESORERIA POR PAGO" },
    { value: "48", label: "PAGADO" },
    { value: "49", label: "ADMINISTRACION POR FIRMA" }
  ];

  const tiposOrden = [
    { value: "0", label: "TODAS" },
    { value: "1", label: "TRASLADO DE FONDOS DE TERCEROS" },
    { value: "2", label: "REPOSICIÓN DE CHEQUES" },
    { value: "3", label: "ANTICIPOS DE OBRAS" },
    { value: "4", label: "TRANSFERENCIAS BANCARIAS" },
    { value: "5", label: "REINTEGROS" },
    { value: "6", label: "APERTURA DE CAJA CHICA" },
    { value: "7", label: "FONDO DE AVANCE" },
    { value: "8", label: "CUENTAS POR PAGAR" },
    { value: "9", label: "ANTICIPOS A PROVEEDORES" },
    { value: "10", label: "JUZGADO DE MENORES" }
  ];

  const titulo = {
    100: 'Listado General de Ordenes de Pago',
    101: 'Listado Detallado de Compromisos',
    102: 'Ordenes de Pago por tipo de Compromiso',
    103: 'Ordenes de Pago por Beneficiario',
    104: 'Resumen de Cuentas por Pagar',
    105: 'Ubicacion de Compromisos', // Título original, aunque es Cheques
    106: 'Ubicacion de Ordenes de Pago',
    107: 'Listado General de Pagos x Proveedor',
    108: 'Ordenes de Pago Financiera por Tipo',
  }

  // --- FUNCIONES AUXILIARES ---
  const lpad = (str, pad, length) => {
    while (str.length < length) {
      str = pad + str;
    }
    return str;
  }

  const diasMes = (mes, anio) => {
    return new Date(anio, mes, 0).getDate();
  }

  // --- FUNCION LIMPIAR ---
  const limpiar = () => {
    // Limpiar Textos
    if (bancoCodigoRef.current) bancoCodigoRef.current.value = "";
    if (bancoNombreRef.current) bancoNombreRef.current.value = "";
    if (fechaDesdeRef.current) fechaDesdeRef.current.value = "";
    if (fechaHastaRef.current) fechaHastaRef.current.value = "";
    if (provCodigoRef.current) provCodigoRef.current.value = "";
    if (provNombreRef.current) provNombreRef.current.value = "";

    // Limpiar Checks/Radios
    if (checkResumenRef.current) checkResumenRef.current.checked = false;

    // Resetear Radios a default (ej. Todas)
    if (radioEstadoTodasRef.current) { radioEstadoTodasRef.current.checked = true; }
    if (radioTipoOrdTodasRef.current) { radioTipoOrdTodasRef.current.checked = true; }
    if (radioAgrupNoRef.current) { radioAgrupNoRef.current.checked = true; } // Default 'No'
    // Nota: radioUbiCausadosRef no se resetea ya que no se usa en los reportes implementados

    // Resetear Selects
    if (tipoCompromisoRef.current) tipoCompromisoRef.current.value = "";
    if (ubicacionRef.current) ubicacionRef.current.value = "";
    if (tipoOrdenRef.current) tipoOrdenRef.current.value = "";

    // Resetear Estado Proveedor
    setModoProveedor('seleccionar');

    props.cancelar();
  }

  const cerrar = () => {
    props.cancelar()
  }

  // --- FUNCION IMPRIMIR ---
  const imprimir = () => {
    let idEfi = idefiscal;
    let tit = titulo[props.reporte] || 'Reporte';
    let org = post.nombreorg;

    // --- REPORTE 100: Listado General de Ordenes de Pago (tiporep 1) ---
    if (props.reporte === 100) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;
        let bancoCod = bancoCodigoRef.current.value;

        if (!fDesde) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Inicio.", icono: "informacion" });
          fechaDesdeRef.current.focus();
          return;
        } else if (!fHasta) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Fin.", icono: "informacion" });
          fechaHastaRef.current.focus();
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let banco = "";
        if (bancoCod && bancoCod.trim() !== "") {
          banco = " AND ORD.IDCUENTABANCARIA = " + bancoCod.trim();
        } else {
          banco = " AND TRUE";
        }

        let sql = "";
        let sql2 = "";
        let sql3 = "";
        let sql4 = "";

        if (radioEstadoTodasRef.current.checked) {
          sql = "ORD.Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
          sql3 = "  ";
        } else if (radioEstadoPagadasRef.current.checked) {
          sql = "ORD.FechaPagada Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'" + "AND ORD.FechaPagada NOTNULL";
          sql3 = "PAGADAS";
        } else if (radioEstadoPorPagarRef.current.checked) {
          sql = "ORD.Fecha Between " + "'" + val2 + "'" + " AND " + "'" + val3 + "'" + " AND (ORD.FechaPagada Not Between " + "'" + val2 + "'" + " AND " + "'" + val3 + "'" + "OR ORD.FechaPagada ISNULL) AND (ORD.Reversado = 0 OR (ORD.Reversado = 1 AND ORD.Fecha_Reverso Not Between " + "'" + val2 + "'" + " AND " + "'" + val3 + "'))";
          sql3 = "POR PAGAR";
        } else if (radioEstadoAnuladasRef.current.checked) {
          sql = "ORD.Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'" + "AND ORD.Reversado = 1";
          sql3 = "ANULADAS";
        }

        if (radioTipoOrdTodasRef.current.checked) {
          sql4 = " true ";
        } else if (radioTipoOrdPresupRef.current.checked) {
          sql4 = "ORD.tipo in  (0,1) ";
        } else if (radioTipoOrdFinanRef.current.checked) {
          sql4 = "ORD.tipo =  3 ";
        } else if (radioTipoOrdTercerosRef.current.checked) {
          sql4 = "ORD.tipo =  2 ";
        }

        sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "";
        // Lógica de selección de archivo según Java (Tiporep 1)
        if (radioAgrupDetalleRef.current.checked) {
          fileName = (espiritu === 0 || espiritu === 1 || espiritu === 9 || espiritu === 12 || espiritu === 13 || espiritu === 14 || espiritu === 15 || espiritu === 16)
            ? "Pres_OrdenesxCuentasNumOrden"
            : "Pres_OrdenesxCuentas";

        } else if (radioAgrupSiRef.current.checked) {
          if (espiritu === 0 || espiritu === 9 || espiritu === 1 || espiritu === 12 || espiritu === 13 || espiritu === 14 || espiritu === 15 || espiritu === 16) {
            fileName = radioEstadoTodasRef.current.checked ? "Tes_PagosGenNumOrden" : "Tes_PagosGenNumOrden1";
          } else {
            fileName = "Tes_PagosGen";
          }

        } else {
          if (espiritu === 0 || espiritu === 1 || espiritu === 9 || espiritu === 12 || espiritu === 13 || espiritu === 14 || espiritu === 15 || espiritu === 16) {
            fileName = radioEstadoTodasRef.current.checked ? "Tes_PagosNumOrden" : "Tes_PagosNumOrden1";
          } else {
            if (checkResumenRef.current && checkResumenRef.current.checked) {
              fileName = "Tes_PagosResumen";
            } else {
              fileName = "Tes_Pagos";
            }
          }
        }

        let condicionCompleta = sql.trim() + " AND " + sql4.trim() + banco;
        let sql2_texto = sql2.trim();
        let Sql3_texto = sql3.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&TIT_CRI1=" + encodeURIComponent(Sql3_texto) +
          "&HASTA=" + encodeURIComponent(fFin) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
      }
    }

    // --- REPORTE 101: Listado Detallado de Compromisos (tiporep 46) ---
    else if (props.reporte === 101) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;
        if (!fDesde) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Inicio.", icono: "informacion" });
          fechaDesdeRef.current.focus();
          return;
        } else if (!fHasta) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Fin.", icono: "informacion" });
          fechaHastaRef.current.focus();
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let sql1 = "";
        if (modoProveedor === 'seleccionar' && provCodigoRef.current.value.trim() !== "") {
          sql1 = "PROV.idproveedor = " + provCodigoRef.current.value.trim();
        } else {
          sql1 = "true";
        }

        let sql = "Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";
        let fileName = "Relacion_Ordenes";

        let condicionCompleta = sql.trim() + " AND " + sql1.trim();
        let sql2_texto = sql2.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&TIT_CRI1=" + encodeURIComponent("") +
          "&HASTA=" + encodeURIComponent(fFin) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
      }
    }

    // --- REPORTE 102: Listado de Ordenes de Pago por Tipo de Compromiso (tiporep 2) ---
    else if (props.reporte === 102) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Inicio.", icono: "informacion" });
          return;
        } else if (!fHasta) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Fin.", icono: "informacion" });
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let tipoVal = tipoCompromisoRef.current.value;
        let sql1 = "true";

        // Validación corregida según valores del array y lógica Java
        if (tipoVal === "5") {
          sql1 = "CPG.tipo = 5"; // ORDEN DE COMPRA
        } else if (tipoVal === "7") {
          sql1 = "CPG.tipo = 7"; // PAGO DE OBRAS
        } else if (tipoVal === "11") {
          sql1 = "CPG.tipo = 11"; // ORDEN DE SERVICIO
        } else if (tipoVal === "12") {
          sql1 = "CPG.tipo = 12"; // PAGO DIRECTO
        } else if (tipoVal === "13") {
          sql1 = "CPG.tipo = 13"; // PAGO DE NOMINA
        }

        let sql = "ORD.Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "";
        if (espiritu && [0, 1, 9, 12, 13, 14, 15, 16].includes(espiritu)) {
          fileName = "Adm_PagxCompromNumOrden";
        } else {
          fileName = "Adm_PagxComprom";
        }

        let condicionCompleta = sql.trim() + " AND " + sql1.trim();
        let sql2_texto = sql2.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&TIT_CRI1=" + encodeURIComponent("") +
          "&HASTA=" + encodeURIComponent(fFin) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
      }
    }

    // --- REPORTE 103: Listado de Ordenes de Pago por Beneficiario (tiporep 3) ---
    else if (props.reporte === 103) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Inicio.", icono: "informacion" });
          fechaDesdeRef.current.focus();
          return;
        } else if (!fHasta) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Fin.", icono: "informacion" });
          fechaHastaRef.current.focus();
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let sql1 = "";
        if (modoProveedor === 'seleccionar' && provCodigoRef.current.value.trim() !== "") {
          sql1 = "idproveedor = " + provCodigoRef.current.value.trim();
        } else {
          sql1 = "true";
        }

        let sql = "ORD.Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "";
        if (espiritu && [0, 1, 9, 12, 13, 14, 15, 16].includes(espiritu)) {
          fileName = "Adm_PagosxBenefNumOrden";
        } else {
          fileName = "Adm_PagosxBeneficiario";
        }

        let condicionCompleta = sql.trim() + " AND " + sql1.trim();
        let sql2_texto = sql2.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&TIT_CRI1=" + encodeURIComponent("") +
          "&HASTA=" + encodeURIComponent(fFin) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
      }
    }

    // --- REPORTE 104: Listado de Cuentas por Pagar (tiporep 44) ---
    else if (props.reporte === 104) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Inicio.", icono: "informacion" });
          fechaDesdeRef.current.focus();
          return;
        } else if (!fHasta) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Fin.", icono: "informacion" });
          fechaHastaRef.current.focus();
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let tipoVal = tipoCompromisoRef.current.value;
        let sql1 = "true";

        // Validación corregida según lógica Java case 5, 7, 11
        if (tipoVal === "5") {
          sql1 = "CPG.tipo = 5"; // ORDEN DE COMPRA
        } else if (tipoVal === "7") {
          sql1 = "CPG.tipo = 7"; // PAGO DE OBRAS
        } else if (tipoVal === "11") {
          sql1 = "CPG.tipo = 11"; // ORDEN DE SERVICIO
        } else if (tipoVal === "12") {
          sql1 = "CPG.tipo = 12"; // ORDEN DE SERVICIO
        } else if (tipoVal === "13") {
          sql1 = "CPG.tipo = 13"; // ORDEN DE SERVICIO
        } else {
          sql1 = "true"
        }



        let sql3 = "true";
        if (modoProveedor === 'seleccionar' && provCodigoRef.current.value.trim() !== "") {
          sql3 = "idproveedor = " + provCodigoRef.current.value.trim();
        } else {
          sql3 = "true";
        }

        let sql = "CPG.Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";
        let sql4 = "Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";

        let fileName = "CuentasxPagarProv";

        let condicionCompleta = sql.trim() + " AND " + sql1.trim() + " AND " + sql3.trim();
        let condicion1 = sql4.trim();

        let sql2_texto = sql2.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&CONDICION_1=" + encodeURIComponent(condicion1) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&TIT_CRI1=" + encodeURIComponent("") +
          "&HASTA=" + encodeURIComponent(fFin) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
      }
    }

    // --- REPORTE 105: Ubicacion de Compromisos (tiporep 28) ---
    else if (props.reporte === 105) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Introducir la Fecha de Inicio.",
            icono: "informacion"
          });
          fechaDesdeRef.current.focus();
          return;
        } else if (!fHasta) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Introducir la Fecha de Fin.",
            icono: "informacion"
          });
          fechaHastaRef.current.focus();
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        // Lógica basada en Java: radioButton.getSelection() ? "COMPROMISOS CAUSADOS" : radioButton1.getSelection() ? "COMPROMISOS POR CAUSAR": " ";
        let ubi = null, condi = null;

        if (radioEstadoCausados.current.checked) {
          ubi = "CPG.UBICACION = 42 and CPG.status = 1";
          condi = "COMPROMISOS CAUSADOS";
        } else if (radioEstadoPorCausar.current.checked) {
          ubi = "CPG.UBICACION = 42 and CPG.status = 0";
          condi = "COMPROMISOS POR CAUSAR";
        } else {
          ubi = "TRUE";
          condi = " ";
        }

        let sql = "CPG.Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "' and " + ubi;
        let sql2 = condi + " DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA " + " " + "'" + val3 + "'";

        // Nota: En Java usa "Pres_CompromisoFch.jasper" para tiporep 28
        // Verifica si necesitas un archivo .jasper diferente para este reporte
        let fileName = "Pres_CompromisoFch"; // o el nombre correcto según tu sistema

        // Si hay lógica especial para diferentes "espiritu" como en otros reportes:
        if (espiritu && [0, 1, 9, 12, 13, 14, 15, 16].includes(espiritu)) {
          // fileName = "Pres_CompromisoFch_NumOrden"; // si existe variante
        }

        let condicionCompleta = sql.trim();
        let sql2_texto = sql2.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&RGO_FCHINI=" + encodeURIComponent("'" + val2.trim() + "'") +
          "&RGO_FCHFIN=" + encodeURIComponent("'" + val3.trim() + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte 105:", error);
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.message,
          icono: 'error'
        });
      }
    }

    // --- REPORTE 106: Ubicacion de Compromisos (tiporep 4) ---
    else if (props.reporte === 106) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Inicio.", icono: "informacion" });
          fechaDesdeRef.current.focus();
          return;
        } else if (!fHasta) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Fin.", icono: "informacion" });
          fechaHastaRef.current.focus();
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let ubicacionVal = ubicacionRef.current.value;
        let sql1 = "true";

        // Validación corregida: Comparar directamente con IDs del array (44, 45, 46)
        if (ubicacionVal === "44") {
          sql1 = "ORD.ubicacion = 44"; // TESORERIA POR CHEQUE
        } else if (ubicacionVal === "45") {
          sql1 = "ORD.ubicacion = 45"; // DESPACHO
        } else if (ubicacionVal === "46") {
          sql1 = "ORD.ubicacion = 46"; // TESORERIA POR PAGO
        }
        // Si es "100" (TODOS), sql1 se queda como "true"

        let sql = "ORD.Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "";
        if (espiritu && [0, 1, 9, 12, 13, 14, 15, 16].includes(espiritu)) {
          fileName = "Adm_UbicPagosNumOrden";
        } else {
          fileName = "Adm_UbicPagos";
        }

        let condicionCompleta = sql.trim() + " AND " + sql1.trim();
        let sql2_texto = sql2.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&TIT_CRI1=" + encodeURIComponent("") +
          "&HASTA=" + encodeURIComponent(fFin) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
      }
    }

    // --- REPORTE 107: Resumen de Pago por Beneficiario (tiporep 48) ---
    else if (props.reporte === 107) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Inicio.", icono: "informacion" });
          fechaDesdeRef.current.focus();
          return;
        } else if (!fHasta) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Fin.", icono: "informacion" });
          fechaHastaRef.current.focus();
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let sqlProv = "";
        if (modoProveedor === 'seleccionar' && provCodigoRef.current.value.trim() !== "") {
          sqlProv = " and  idproveedor = " + provCodigoRef.current.value.trim();
        }

        let sql = "ORDP_Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "";
        if (espiritu && [0, 1, 9, 12, 13, 14, 15, 16].includes(espiritu)) {
          fileName = "Tes_Pagos_ChequeNumOrden";
        } else {
          fileName = "Tes_Pagos_Cheque";
        }

        let condicionCompleta = sql.trim() + ' ' + sqlProv.trim();
        let sql2_texto = sql2.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&TIT_CRI1=" + encodeURIComponent("") +
          "&HASTA=" + encodeURIComponent(fFin) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
      }
    }

    // --- REPORTE 108: Ordenes de Pago Financiera por Tipo (tiporep 56) ---
    else if (props.reporte === 108) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Inicio.", icono: "informacion" });
          fechaDesdeRef.current.focus();
          return;
        } else if (!fHasta) {
          setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe Introducir la Fecha de Fin.", icono: "informacion" });
          fechaHastaRef.current.focus();
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let tipoVal = tipoOrdenRef.current.value;
        let sql1 = "true";

        if (tipoVal === "0") {
          sql1 = "true";
        } else {
          // Java: ORD.clase = (cmbTipoComp.getSelectionIndex() - 1)
          // Nuestro array value empieza en "1" para el primer item real. 1 - 1 = 0.
          sql1 = "ORD.clase = " + (parseInt(tipoVal) - 1);
        }

        let sql = "ORD.Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "";
        /* if (espiritu && [0, 1, 9, 12, 13, 14, 15, 16].includes(espiritu)) {
          fileName = "Tes_PagosFinancieraNumOrden";
        } else {
          fileName = "Tes_PagosFinanciera";
        } */
       fileName = "Tes_PagosFinancieraNumOrden";

        let condicionCompleta = sql.trim() + " AND " + sql1.trim();
        let sql2_texto = sql2.trim();
        let fFin = "'" + val3 + "'";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&TIT_CRI1=" + encodeURIComponent("") +
          "&HASTA=" + encodeURIComponent(fFin) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
      }
    }
  };

  const onHideCuentaBancaria = (values) => {
    setMostrar(false)
    console.log(values)
    bancoCodigoRef.current.value = values.idcuentabancaria;
    bancoNombreRef.current.value = values.nombre.trim() + ' / ' + values.cuentabancaria;
  }

  const handleCancelar = () => {
    // Restablecer a valores por defecto
    const fechaActual = new Date().toISOString().split('T')[0];
    //const añoActual = new Date().getFullYear().toString();
    const añoActual = new Date(fechasistema).getFullYear().toString();

    if (fechaDesdeRef.current) {
      fechaDesdeRef.current.value = fechaActual;
    }
    if (fechaHastaRef.current) {
      fechaHastaRef.current.value = fechaActual;
    }
    if (tipoCompromisoRef.current) {
      tipoCompromisoRef.current.value = opcionesCompromiso[0].value;
    }
  };

  const onHideAceptaCatProv = (responsable, razonsocial, idproveedor, rif) => {
    setMostrar2(false)
    console.log(responsable, razonsocial, idproveedor, rif)
    provCodigoRef.current.value = idproveedor
    provNombreRef.current.value = razonsocial + ' '+rif
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          {titulo[props.reporte] || 'Reporte'}
        </h3>
        <button className="btn btn-sm bg-light" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
          }}
        />
        <CatalogoCuentaBancaria
          show={mostrar}
          onHideCancelar={() => setMostrar(false)}
          onHideAceptaCatalogo={onHideCuentaBancaria}

        />

        <div className="col-md-12 row mx-auto px-0">

          {/* --- SECCIÓN REPORTE 100 y 105: BANCO --- */}
          {props.reporte === 100 ?
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Banco</legend>
              <div className="input-group input-group-sm col-md-12 mx-auto mb-1">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Codigo:</span>
                <input
                  ref={bancoCodigoRef}
                  type="text"
                  disabled
                  className="form-control text-uppercase col-md-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button type="button" onClick={() => { setMostrar(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>
                <input
                  ref={bancoNombreRef}
                  type="text"
                  disabled
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </fieldset>
            : ''}

          {/* --- SECCIÓN REPORTE 100: AGRUPADO POR TIPO --- */}
          {props.reporte === 100 ?
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto mt-2 rounded">
              <div className="col-md-5 row mx-auto mb-2">
                <label className="my-auto text-uppercase fw-bold my-auto">
                  Agrupado por Tipo de Ordenes
                </label>
              </div>

              <div className="col row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioAgrupSiRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioAgrupado"
                    id="radioAgrupSi"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioAgrupSi">
                    Si
                  </label>
                </div>
              </div>

              <div className="col row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioAgrupNoRef}
                    defaultChecked
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioAgrupado"
                    id="radioAgrupNo"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioAgrupNo">
                    No
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioAgrupDetalleRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioAgrupado"
                    id="radioAgrupDetalle"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioAgrupDetalle">
                    Detalle de Cuentas
                  </label>
                </div>
              </div>
            </div>
            : ''}

          {/* --- SECCIÓN REPORTE 100 y 105: ESTADO --- */}
          {props.reporte === 100 ?
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
              <div className="col row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioEstadoTodasRef}
                    defaultChecked
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEstado"
                    id="radioEstadoTodas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstadoTodas">
                    Todas
                  </label>
                </div>
              </div>

              <div className="col row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioEstadoPagadasRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEstado"
                    id="radioEstadoPagadas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstadoPagadas">
                    Pagadas
                  </label>
                </div>
              </div>

              <div className="col-md-3 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioEstadoPorPagarRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEstado"
                    id="radioEstadoPorPagar"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstadoPorPagar">
                    Por Pagar
                  </label>
                </div>
              </div>

              <div className="col-md-3 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioEstadoAnuladasRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEstado"
                    id="radioEstadoAnuladas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstadoAnuladas">
                    Anuladas
                  </label>
                </div>
              </div>
            </div>
            : ''}

          {props.reporte === 105 ?
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
              <div className="col row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioEstadoTodasCausas}
                    defaultChecked
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEstado"
                    id="radioEstadoTodas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstadoTodas">
                    Todas
                  </label>
                </div>
              </div>

              <div className="col row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioEstadoCausados}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEstado"
                    id="radioEstadoPagadas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstadoPagadas">
                    Causados
                  </label>
                </div>
              </div>

              <div className="col-md-3 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioEstadoPorCausar}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEstado"
                    id="radioEstadoPorPagar"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstadoPorPagar">
                    Por Causar
                  </label>
                </div>
              </div>


            </div>
            : ''}

          {/* --- SECCIÓN REPORTE 100: TIPO DE ORDENES --- */}
          {props.reporte === 100 ?
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded row">
              <legend className="float-none text-uppercase w-auto m-0">Tipo de Ordenes</legend>

              <div className="col-md-12 row mx-auto px-0 mb-2">
                <div className="form-check col-md-2 ml-auto">
                  <input
                    ref={checkResumenRef}
                    className="form-check-input text-uppercase"
                    type="checkbox"
                    value=""
                    id="checkDefault"
                  />
                  <label className="form-check-label text-uppercase text-uppercase fw-bold" htmlFor="checkDefault">
                    Resumen
                  </label>
                </div>
              </div>

              <div className="col-md-12 row mx-auto px-0 py-auto">
                <div className="col row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      ref={radioTipoOrdTodasRef}
                      defaultChecked
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoOrd"
                      id="radioTipoOrdTodas"
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoOrdTodas">
                      Todas
                    </label>
                  </div>
                </div>

                <div className="col row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      ref={radioTipoOrdPresupRef}
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoOrd"
                      id="radioTipoOrdPresup"
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoOrdPresup">
                      Presupuestarias
                    </label>
                  </div>
                </div>

                <div className="col-md-3 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      ref={radioTipoOrdFinanRef}
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoOrd"
                      id="radioTipoOrdFinan"
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoOrdFinan">
                      Financieras
                    </label>
                  </div>
                </div>

                <div className="col-md-3 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      ref={radioTipoOrdTercerosRef}
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoOrd"
                      id="radioTipoOrdTerceros"
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoOrdTerceros">
                      Fondo de Terceros
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
            : ''}

          {/* --- SECCIÓN GENERAL: BUSCAR POR (FECHAS) --- */}
          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded row">
            <legend className="float-none text-uppercase w-auto m-0">Buscar Por</legend>

            <div className="col-md-12 mx-auto row my-auto py-0">
              <div className="input-group input-group-sm col-md-5 mb-0">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Desde la Fecha:</span>
                <input
                  ref={fechaDesdeRef}
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                />
              </div>
              <div className="input-group input-group-sm col-md-5 mb-0">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Hasta la Fecha:</span>
                <input
                  ref={fechaHastaRef}
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                />
              </div>
            </div>
          </fieldset>

          {/* --- SECCIÓN SELECT: TIPO DE COMPROMISO (MAP) --- */}
          {props.reporte === 102 || props.reporte === 104 ?
            <div className="input-group input-group-sm col-md-12 mx-auto mb-1 px-0 mt-2">
              <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Tipo de Compromiso:</span>
              <select
                ref={tipoCompromisoRef}
                className="form-select"
                aria-label="Default select example"
              >
                {/*<option value="">Seleccione una opción</option>*/}
                {opcionesCompromiso.map((op) => (
                  <option key={op.value} value={op.value}>
                    {op.label}
                  </option>
                ))}
              </select>
            </div>
            : ''}

          {/* --- SECCIÓN SELECT: UBICACIÓN (MAP) --- */}
          {props.reporte === 106 ?
            <div className="input-group input-group-sm col-md-12 mx-auto mb-1 px-0 mt-2">
              <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Ubicación:</span>
              <select
                ref={ubicacionRef}
                className="form-select"
                aria-label="Default select example"
              >
                <option value="">Seleccione una opción</option>
                {ubicaciones.map((op) => (
                  <option key={op.value} value={op.value}>
                    {op.label}
                  </option>
                ))}
              </select>
            </div>
            : ''}

          {/* --- SECCIÓN PROVEEDOR (RADIO) --- */}
          {props.reporte === 101 || props.reporte === 103 || props.reporte === 104 || props.reporte === 107 ?
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioProvSelectRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioProveedor"
                    id="radioProvSelect"
                    checked={modoProveedor === 'seleccionar'}
                    onChange={() => setModoProveedor('seleccionar')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvSelect">
                    Selecionar Proveedor
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioProvTodosRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioProveedor"
                    id="radioProvTodos"
                    checked={modoProveedor === 'todos'}
                    onChange={() => setModoProveedor('todos')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvTodos">
                    Todos
                  </label>
                </div>
              </div>
            </div>
            : ''}

          {/* --- SECCIÓN PROVEEDOR (INPUTS) - CONDICIONAL --- */}
          {modoProveedor === 'seleccionar' && (props.reporte === 101 || props.reporte === 103 || props.reporte === 104 || props.reporte === 107) ?
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Proveedor</legend>
              <div className="input-group input-group-sm col-md-12 mx-auto mb-1">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Codigo:</span>
                <input
                  ref={provCodigoRef}
                  type="text"
                  disabled
                  className="form-control text-uppercase col-md-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button onClick={() => setMostrar2(true)} type="button" className="btn btn-success"><i className="fas fa-search"></i></button>
                <input
                  ref={provNombreRef}
                  type="text"
                  disabled
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </fieldset>
            : ''}

          {/* --- SECCIÓN SELECT: TIPO DE ORDEN (MAP) --- */}
          {props.reporte === 108 ?
            <div className="input-group input-group-sm col-md-12 mx-auto mb-1 px-0 mt-2">
              <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Tipo de Orden:</span>
              <select
                ref={tipoOrdenRef}
                className="form-select"
                aria-label="Default select example"
              >
                {/*<option value="">Seleccione una opción</option>*/}
                {tiposOrden.map((op) => (
                  <option key={op.value} value={op.value}>
                    {op.label}
                  </option>
                ))}
              </select>
            </div>
            : ''}

          {/* Mensaje de Alerta 
          {mensaje.mostrar && (
            <div className="alert alert-warning alert-dismissible fade show mt-2" role="alert">
              <strong>{mensaje.titulo}</strong> {mensaje.texto}
              <button type="button" className="btn-close" onClick={() => setMensaje({ ...mensaje, mostrar: false })}></button>
            </div>
          )}*/}

        </div>

        <CatalogoProveedorPresupuesto
          show={mostrar2}
          onHideCancelar={() => setMostrar2(false)}
          onHideAceptaProveedor={onHideAceptaCatProv}

        />

      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-primary text-uppercase" onClick={imprimir}>
          <i className="fas fa-print me-2"></i> Imprimir
        </button>
        <button className="btn btn-sm btn-secondary text-uppercase" onClick={handleCancelar}>
          <i className="fas fa-times me-2"></i> Cancelar
        </button>
        <button className="btn btn-sm btn-danger text-uppercase" onClick={limpiar}>
          <i className="fas fa-times me-1"></i> Salir
        </button>
      </Modal.Footer>

    </Modal>
  );
};